import React from 'react';
import { toastr } from 'react-redux-toastr';
import RetryToastAction from './components/RetryToastAction';

const retryToasts = new Map();

export const clearApiRetry = (title, retryKey) => {
	retryToasts.forEach((toast, key) => {
		if (
			toast.title === title &&
			(retryKey === undefined || toast.retryKey === retryKey)
		) {
			retryToasts.delete(key);
			toast.remove();
		}
	});
};

export const canRetryRequest = ({ error, message }) => {
	const status = error?.response?.status;
	if (status) return [408, 502, 503, 504].includes(status);
	return (
		['ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK'].includes(error?.code) ||
		/network error|timed?\s*out|historical data is being restored|historical data is temporarily unavailable/i
			.test(error ? getErrorMessage(error) : message || '')
	);
};

export const getErrorMessage = (error) => {
	const data = error.response?.data;
	if (typeof data?.message === 'string' && data.message) return data.message;
	if (typeof data === 'string' && data) return data;
	if (error.response?.status === 413) {
		return 'The result set is too large to return. Please narrow your search criteria.';
	}
	return error.message || 'Unable to load data. Please try again later.';
};

export const showApiMessages = ({
	response = {},
	sites = [],
	title = 'Data',
	retryKey = '',
	onRetry
}) => {
	clearApiRetry(title, retryKey);
	const { warnings = [], error, message, loading } = response;
	if (loading) return;

	warnings.forEach(({ code, message, siteIds = [] }) => {
		const affectedSites = siteIds.map((siteId) => {
			const site = sites.find(({ id }) => String(id) === String(siteId));
			return site ? `${site.name} (ID: ${siteId})` : `Site ID: ${siteId}`;
		}).join(', ');
		const warningMessage =
			message ||
			(code === 'INCOMPLETE_DATA'
				? 'Source history is incomplete for some requested sites.'
				: 'Site history warning.');
		toastr.warning(
			title,
			affectedSites
				? `${warningMessage} Affected sites: ${affectedSites}`
				: warningMessage
		);
	});
	if (error || message) {
		const errorMessage = error ? getErrorMessage(error) : message;
		if (onRetry && canRetryRequest(response)) {
			const key = JSON.stringify([title, retryKey]);
			toastr.error(title, errorMessage, {
				timeOut: 0,
				preventDuplicates: false,
				removeOnHover: false,
				closeOnToastrClick: false,
				component: (
					<RetryToastAction
						onRetry={onRetry}
						onMount={(remove) => {
							retryToasts.set(key, { title, retryKey, remove });
						}}
						onUnmount={(remove) => {
							if (retryToasts.get(key)?.remove === remove) retryToasts.delete(key);
						}}
					/>
				)
			});
		} else {
			toastr.error(title, errorMessage);
		}
	}
};
